<script setup lang="ts">
import Badge from './Badge.vue';

type BadgeSize = 'sm' | 'md' | 'lg';

withDefaults(
  defineProps<{
    percentage: number;
    size?: BadgeSize;
    position?: 'overlay' | 'inline';
  }>(),
  {
    size: 'sm',
    position: 'overlay'
  }
);
</script>

<template>
  <Badge
    :size="size"
    :position="position"
    variant="bg-red-500 text-white border"
  >
    -{{ percentage }}%
  </Badge>
</template>
